import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';
import { HttpClient } from '@angular/common/http';
import { UserSettings } from './usersettings';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
var moment = require('moment');
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { CommonFunction } from '../main/CommonFunction';
import { Subscription } from 'rxjs';
import { CustomDateFormat } from './CustomDateFormat';
import { DatePipe } from '@angular/common';
import { CommonReportService } from '../shared/services/CommonReportService.service';
@Component({
    selector: 'customer-outstanding-template',
    template: require('./CommonCustomerOutstandingTemplate.html'),
    styles: [``]
})
export class CommonCustomerOutstandingTemplateComponent implements OnInit {
    @Input('customername') Customer_Name: any;
    @Input('name') Name: any;
    @Input('customerid') Customer_ID: any;
    @Input("dValue") dvalue: any;

    static parameters = [UtilityService, HttpClient, NgbModal, HotkeysService, BsDatepickerConfig, CommonFunction, CustomDateFormat, DatePipe, CommonReportService]
    bsConfig: any;
    busy: Subscription;
    public overlayNoRowsTemplate: any;
    toastWarningMsg(msg) {
        this.toast({ type: 'warning', title: msg });
    }

    constructor(public utilityService: UtilityService, public http: HttpClient, private modalService: NgbModal, private hotkeysService: HotkeysService, public _bsDatepickerConfig: BsDatepickerConfig, public commonFunction: CommonFunction, public customDateFormat: CustomDateFormat, public datePipe: DatePipe, public commonReportService: CommonReportService) {
        this.http = http;
        this.modalService = modalService;
        this.hotkeysService = hotkeysService;
        this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
        this.dateFormat = JSON.parse(localStorage.getItem('permission'))[0];
        this.bsConfig = Object.assign({}, { dateInputFormat: this.unitInfo.dateInputFormat, containerClass: this.unitInfo.dateColorTheme });
        this._bsDatepickerConfig.dateInputFormat = this.unitInfo.dateInputFormat;

        this.defaultColDef = {
            resizable: true,
            sortable: true
        };

        $(document).ready(function () {
            var header = $('customer-outstanding-template .modal-header').height();
            var body = $('customer-outstanding-template').parent().height();
            var appHeight = body - header + 'px !important';
            $('.modal-body .table-responsive.outstanding').attr('style', 'height:' + appHeight);
        })
    }

    CustOutstandingRowData: any;
    CustOutstandingRowDataExport: any;
    customeroutstandingDef: any;
    gridColumnApiCustomerOustanding: any;
    gridApiCustomerOustanding: any;
    gridApiCustomerOustandingExport: any;
    paginationConf: any;
    d: any;
    defaultColDef: any;
    rowSelectionSingle: string;
    searchValue: any;
    unitInfo: any;
    searchobject: any;
    modalReference: NgbModalRef;
    public overlayLoadingTemplate: any;
    public hotkeyList: Hotkey[];
    rowClassRules: any;
    public Config_Leger_From_Date: any;
    dateFormat: any;
    Custfiltervalue: any;

    toast = Swal.mixin({
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 3000,
        backdrop: `rgba(30, 30, 37, 0.4)`
    });

    ngOnInit(): void {
        this.rowSelectionSingle = "single";
        this.d = this.dvalue;
        this.searchobject = {};
        this.overlayNoRowsTemplate = "<h4> No record to show. </h4>";
        this.paginationConf = UserSettings.enablePagination;
        var self = this;
        if ("SystemConfigDetails" in localStorage) {
            var data = JSON.parse(localStorage.getItem('SystemConfigDetails'));
            var ConfigDate = data.filter(function (item) {
                return item.Config_Name === 'Customer Ledger From Date'
            });
            //var currentdate = moment(new Date()).format('YYYY');
            this.Config_Leger_From_Date = (ConfigDate ? ConfigDate[0].Config_Value : '');
            if (this.Config_Leger_From_Date) {
                this.Config_Leger_From_Date = (this.unitInfo.CurrentFYear + "-" + this.Config_Leger_From_Date);
                this.Config_Leger_From_Date = moment(this.Config_Leger_From_Date).format(this.dateFormat.dateInputFormat);
            } else {
                this.Config_Leger_From_Date = this.oneMonthAgo();
            }
        }
        this.customeroutstandingDef = [
            { headerName: 'Doc Type', field: 'DocType_Desc', width: 100 },
            { headerName: 'Doc No', field: 'Doc_No', width: 100 },
            {
                headerName: 'Doc Date', field: 'Post_Date', width: 110, cellRenderer: (data) => {
                    return data.value ? moment(data.value).format(this.unitInfo.dateInputFormat) : "";
                }
            },
            {
                headerName: 'Due Date', field: 'Due_Date', width: 110, cellRenderer: (data) => {
                    return data.value ? moment(data.value).format(this.unitInfo.dateInputFormat) : "";
                }
            },
            { headerName: 'Over Days', field: 'OverDays', width: 70, cellStyle: { 'textAlign': "right" } },
            { headerName: 'AGE', field: 'Age', width: 50, cellStyle: { 'textAlign': "right" } },
            { headerName: 'Total Bill Amount', width: 120, field: 'Total_BillAmount', cellStyle: { 'textAlign': "right" } },
            { headerName: 'Adj Amt', field: 'ClrAmt', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: 'Outstanding', field: 'Outstanding', width: 100, cellStyle: { 'textAlign': "right" } },
            { headerName: 'DPM', field: 'DPM', width: 50, cellStyle: { 'textAlign': "right" } },
            { headerName: 'DPT', field: 'DPT', width: 50, cellStyle: { 'textAlign': "right" } },
            {
                headerName: 'Salesman Code',
                field: 'Employee_Code',
                width: 100
              },
              {
                headerName: 'Salesman Name',
                field: 'Employee_Name',
                width: 150
              },
              {
                headerName: 'Area',
                field: 'Area_Name',
                width: 100
              },
              {
                headerName: 'City',
                field: 'City_Desc',
                width: 100
              },

            { headerName: '', field: 'EntryType', width: 50 },
            { headerName: 'D.Tag Remarks', field: 'D_Tag_Remarks', width: 100, editable: (params) => params.data.IsDisputeAllowed == 1 , cellStyle: { 'text-align': "right" } },
            {
                headerName: 'D. Tag',
                field: 'Is_Dispute',
                cellRenderer: function (params: any) {
                  if (Number(params.data.FI_ID) > 0) {
                    var input = document.createElement('input');
                    input.type = 'checkbox';
                    input.checked = params.value;
                    input.disabled = params.data.IsDisputeAllowed ? false : true;
                    input.id = 'SELECT_' + params.data.FI_ID;
                    input.addEventListener('click', function (event) {
                      params.value = Number(!params.value);
                      params.node.data.Is_Dispute = params.value;
                      var data = {
                        IsDispute: params.value,
                        FI_ID: params.node.data.FI_ID,
                      };
                      self.SaveCustomerOutstandingDispute(data);
                    });
                    return input;
                  }
                  return;
                },
                width: 100
              },
              {
                headerName: 'CIO',
                field: 'Is_Dispute_Outstanding',
                Tooltip: 'Consider in outstanding',
                headerTooltip: 'Consider in outstanding',
                width: 50,
                cellRenderer: function (params) {
                    const isDisputeAllowed = params.data.IsDisputeAllowed == 1;
                    const hasRemarks = params.data.D_Tag_Remarks && params.data.D_Tag_Remarks.trim() !== '';
                    const isDTagChecked = params.data.Is_Dispute != 0;
                    const canEdit = isDisputeAllowed && hasRemarks && isDTagChecked;

                    const input = document.createElement('input');
                    input.type = 'checkbox';
                    input.checked = !!params.value;
                    input.disabled = !canEdit;
                    input.id = 'OUTSTANDING_' + params.data.FI_ID;

                    input.addEventListener('click', function (event) {
                    if (!canEdit) return;

                    const newValue = !params.value;
                    params.node.setDataValue('Is_Dispute_Outstanding', newValue);
                        self.SaveCustomerOutstandingDispute({ 
                            FI_ID: params.data.FI_ID,
                            IsDispute: newValue == false ? 1 : 2, // 1 for dispute, 2 for outstanding
                            Is_Dispute_Outstanding: newValue,
                            D_Tag_Remarks: params.data.D_Tag_Remarks,
                            
                        });
                    });
                    return input;
                }
            }
        ];

        this.initHotkeys();
        setTimeout(() => {
            $("#filter-text-box1").focus();
        }, 200);

        this.CustOutstandingRowData = [];
        this.CustOutstandingRowDataExport = [];
        this.overlayLoadingTemplate = "<div class='loader2'>" +
            "<div class='loading'><img src='public/loader-icon-2.svg'></div>" +
            "</div>";

        this.Custfiltervalue = '';
        this.EnableDateRange();
        // this.searchobject.From_Date = this.Config_Leger_From_Date;
        // this.searchobject.To_Date = new Date();

        this.searchobject.With_PDC = true;
        this.searchobject.On_Acc = false;
        this.customerOustandingmain();
    }

    initHotkeys() {
        this.hotkeyList = [];
        let ctrle = new Hotkey('alt+e', (event: KeyboardEvent): boolean => {
            $('customer-outstanding-template #excelbtn').trigger('click');
            return false; // Prevent bubbling
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrle);
        this.hotkeysService.add(ctrle);

        const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {
            $("customer-outstanding-template #filter-text-box1").focus();
            return false;
        }, ['INPUT', 'SELECT', 'TEXTAREA']);
        this.hotkeyList.push(ctrlf);
        this.hotkeysService.add(ctrlf);
    }

    ngAfterViewInit() {
        this.paginationConf = UserSettings.enablePagination;
    }

    f_chkString(p_value) {
        var Val = (p_value ? p_value.toString() : "").trim();
        return Val;
    }

    f_chkNum(p_value) {
        var Val = Number(p_value);
        if (Val) {
            return Val;
        }
        return 0;
    }


    CustOutstandingRowData_1: any;
    customerOustandingmain() {
        this.CustOutstandingRowData = [];
        this.CustOutstandingRowData_1 = [];
        let date = new Date();
        let From_Date = moment(date).format('YYYY-MM-DD');
        let data = {
            "Company_ID": this.unitInfo.Company_ID,
            "Unit_ID": this.unitInfo.Unit_ID,
            "FiscalYear": this.unitInfo.CurrentFYear,
            "sMode": '',
            "Doctype": '',
            "PartyType": "CUS",
            "Party_ID": this.Customer_ID,
            "PostDate": From_Date,
            "FI_Id": '',
            "UserID": this.unitInfo._id,
            "From_Date": moment(this.searchobject.From_Date).format('YYYY-MM-DD'),
            "To_Date": moment(this.searchobject.To_Date).format('YYYY-MM-DD'),
            "With_PDC": this.f_chkNum(this.searchobject.With_PDC),
            "On_Acc": this.f_chkNum(this.searchobject.On_Acc)

        }
        var self = this;
        this.busy = this.http.post('/api/purchaseinvoices/getInvoiceListForPayment_Datefilter', data)
            .subscribe((response: any) => {
                this.CustOutstandingRowData = response;
                this.CustOutstandingRowData_1 = response;

                var TotalRowData = { "Doc_No": "Total Count : " + this.CustOutstandingRowData.length, "OverDays": "Total :", "Total_BillAmount": 0, "ClrAmt": 0, "Outstanding": 0 };

                TotalRowData.Total_BillAmount = (this.CustOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.Total_BillAmount) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);
                TotalRowData.ClrAmt = (this.CustOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.ClrAmt) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);
                TotalRowData.Outstanding = (this.CustOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.Outstanding) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);

                setTimeout(() => {
                    this.gridApiCustomerOustanding.setPinnedBottomRowData([TotalRowData]);
                }, 200);
                setTimeout(() => {
                    if (this.CustOutstandingRowData.length > 0) {
                        this.gridApiCustomerOustanding.getModel().getRow(0).setSelected(true);
                    }
                    let allColumnIds = [];
                    this.gridColumnApiCustomerOustanding.getAllColumns().forEach(function (column) {
                        allColumnIds.push(column.colId);
                    });
                    this.gridColumnApiCustomerOustanding.autoSizeColumns(allColumnIds);
                    this.gridApiCustomerOustanding.sizeColumnsToFit();
                }, 100);


                /* 
                                this.rowClassRules = {
                                    "cheque-return": function (params) {
                                        var Chq_return = params.data.Cheque_Return_Status;
                                        return Chq_return == 1;
                                    }
                                };
                
                                this.rowClassRules = {
                                    "cheque-return-partial": function (params) {
                                        var Chq_return_partial = params.data.Cheque_Return_Status;
                                        return Chq_return_partial == 2;
                                    }
                                }; */

                this.rowClassRules = {
                    "disputed-row-color": function (params) {
                        return params.data.Is_Dispute == 1 || params.data.Is_Dispute_Outstanding == 1;
                    },
                    "cheque-return": function (params) {
                        return params.data.Cheque_Return_Status > 0;
                    }
                };
            })
    }

    CustomerOutstandingGridReady(params) {
        this.gridApiCustomerOustanding = params.api;
        this.gridColumnApiCustomerOustanding = params.columnApi;
        this.gridApiCustomerOustanding.sizeColumnsToFit();
    }

    CustomerOutstandingGridExportReady(params) {
        this.gridApiCustomerOustandingExport = params.api;
        this.gridColumnApiCustomerOustanding = params.columnApi;
        this.gridApiCustomerOustandingExport.sizeColumnsToFit();
    }

    oneMonthAgo() {
        var monthAgo = new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            new Date().getDate()
        );
        return monthAgo;
    }

    exportoutstandingcust() {
        let rowData = [];
        var self = this;
        self.CustOutstandingRowDataExport = [];
        this.gridApiCustomerOustanding.forEachNode(node => rowData.push(node.data));

        rowData.filter(function (item) {
            if (item.Is_Dispute != 1 || item.Is_Dispute_Outstanding == 1) {
                self.CustOutstandingRowDataExport.push(item);
            }
        });

        // grid data update

        var TotalRowData = { "Doc_No": "Total Count : " + self.CustOutstandingRowDataExport.length, "OverDays": "Total :", "Total_BillAmount": 0, "ClrAmt": 0, "Outstanding": 0 };

        TotalRowData.Total_BillAmount = (self.CustOutstandingRowDataExport.reduce(function (acc, sum) {
            return acc + (self.f_chkNum(sum.Total_BillAmount) * self.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
        TotalRowData.ClrAmt = (self.CustOutstandingRowDataExport.reduce(function (acc, sum) {
            return acc + (self.f_chkNum(sum.ClrAmt) * self.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
        TotalRowData.Outstanding = (self.CustOutstandingRowDataExport.reduce(function (acc, sum) {
            return acc + (self.f_chkNum(sum.Outstanding) * self.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
        self.CustOutstandingRowDataExport.push(TotalRowData);
        // grid data update
        this.gridApiCustomerOustandingExport.setRowData(self.CustOutstandingRowDataExport);
        let custName = this.unitInfo.Company_Name + '\n' + this.unitInfo.Company_Full_Address + '\n' + 'Customer Name :' + this.Customer_Name;
        let d = new Date();
        var fName = 'Outstanding_' + d.getTime();
        var params = {
            columnGroups: true,
            skipFooters: false,
            allColumns: true,
            customHeader: custName,
            fileName: fName,
        };
        //this.gridApiCustomerOustanding.exportDataAsCsv(params);
        this.gridApiCustomerOustandingExport.exportDataAsCsv(params);
    }

    onPopupFilterTextBoxChanged(e) {
        let value = $('input#filter-text-box1').val();
        this.gridApiCustomerOustanding.setQuickFilter(value);
         var RowCount = this.gridApiCustomerOustanding.getModel().getRowCount();
        let selectedRows = this.gridApiCustomerOustanding.getSelectedRows();
        var parent = this;

        let rowData = [];
        this.gridApiCustomerOustanding.forEachNodeAfterFilter(node => {
          rowData.push(node.data);
        });
         var TotalRowData = { "Doc_No": "Total Count : " + RowCount, "OverDays": "Total :", "Total_BillAmount": 0, "ClrAmt": 0, "Outstanding": 0 };

        TotalRowData.Total_BillAmount = (rowData.reduce(function (acc, sum) {
            return acc + (parent.f_chkNum(sum.Total_BillAmount) * parent.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
        TotalRowData.ClrAmt = (rowData.reduce(function (acc, sum) {
            return acc + (parent.f_chkNum(sum.ClrAmt) * parent.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
        TotalRowData.Outstanding = (rowData.reduce(function (acc, sum) {
            return acc + (parent.f_chkNum(sum.Outstanding) * parent.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
            setTimeout(() => {
                this.gridApiCustomerOustanding.setPinnedBottomRowData([TotalRowData])
            }, 300);
    }

    CustKeyDown(event) {
        if (event.which == 13) {
            this.gridApiCustomerOustanding.setFocusedCell(0, "Doc_No");
        }
    }

    CustomerOutstandingNavigateScreen(event) {
        let parent = this;
        if (event.keyCode == 13 || event.type == "rowDoubleClicked") {
            let focusedCell = this.gridApiCustomerOustanding.getFocusedCell();
            if (focusedCell && focusedCell.column["colDef"]["field"] == "Doc_No") {
                let selectedRows = this.gridApiCustomerOustanding.getSelectedRows();
                let TransNo = this.f_chkNum(selectedRows[0].Transaction_No);
                let TransType = this.f_chkNum(selectedRows[0].Transaction_Type);
                let Doc_Date = selectedRows[0].Post_Date;
                if (TransNo > 0) {
                    let data_navi = { "ScreenType": TransType, "Transaction_No": TransNo, "Transaction_Date": Doc_Date }
                    parent.commonFunction.Nevigate_Document_Entry(data_navi);
                }
            }
        }
    }

    email_flag: number = 1;
    status: string = "";
    async emailoutstanding() {
        try {
            this.email_flag = 0;
            this.status = "Generating ledger..";
            let rowData = [];
            let FIData = [];

            this.gridApiCustomerOustanding.forEachNode(node => rowData.push(node.data));

            rowData.filter(function (item) {
                if (item.Is_Dispute == 1 && item.Is_Dispute_Outstanding == 0) {
                    FIData.push(item.FI_ID);
                }
            });
            let date = new Date();
            let From_Date = moment(date).format('YYYY-MM-DD');
            var data = {
                "FileName": "Customer_outstanding"
                , "FormatType": "pdf"
                , "params": {
                    Customer: this.Customer_ID,
                    From_Date: this.searchobject.From_Date ? moment(this.searchobject.From_Date).format('YYYY-MM-DD') : "",
                    To_Date: this.searchobject.To_Date ? moment(this.searchobject.To_Date).format('YYYY-MM-DD') : "",
                    FI_ID: '',
                    DTag: FIData.toString(),
                    With_PDC: this.f_chkNum(this.searchobject.With_PDC),
                    PostDate: From_Date
                }
            };
            // return;

            let pdf_filename_path = "";
            let promise = new Promise((resolve, reject) => {
                this.busy = this.commonReportService.GetJasperReport(data).subscribe(pdf_response => {
                    if (pdf_response) {
                        var error = '';
                        error = pdf_response["error"];
                        pdf_filename_path = pdf_response["FilePath"];
                        if (typeof (pdf_filename_path) != "undefined" && pdf_filename_path.length > 0 && error == "") {
                            resolve(pdf_filename_path);
                        } else {
                            reject("");
                        }

                    } else {
                        reject("");
                    }
                });
            });

            let payload = {
                pdf_filename_path: "",
                UnitId: this.unitInfo.Unit_ID,
                CompanyId: this.unitInfo.Company_ID,
                cust_id: this.Customer_ID
            }
            let pdffile = await Promise.all([promise]);

            if (typeof (pdffile) != "undefined" && pdffile.length > 0) {

                payload.pdf_filename_path = pdffile[0].toString();
                this.status = "Sending mail..";
                this.busy = this.http.post('/api/customers/SendEmailLedger', payload).subscribe((data) => {
                    if (typeof (data) != "undefined" && typeof (data["error_code"]) != "undefined" && data["error_code"] == 0) {
                        this.toastWarningMsg(`Mail Successfully sent!`);
                    } else {
                        this.toastWarningMsg(`Failed to sent mail. Please try again!`);
                    }
                    this.email_flag = 1;
                    this.status = "";
                });

            } else {
                this.email_flag = 1;
                this.status = "";
                this.toastWarningMsg(`Failed to generate Outstanding. Please try again!`);
            }
        } catch (ex) {
            this.status = "";
            this.email_flag = 1;
        }

    }

    printoutstanding() {
        // let date = new Date();
        // let From_Date = moment(date).format('YYYY-MM-DD');
        let rowData = [];
        let FIData = [];

        this.gridApiCustomerOustanding.forEachNode(node => rowData.push(node.data));

        rowData.filter(function (item) {
            if (item.Is_Dispute == 1 && item.Is_Dispute_Outstanding == 0) {
                FIData.push(item.FI_ID);
            }
        });
        let date = new Date();
        let From_Date = moment(date).format('YYYY-MM-DD');
        var data = {
            "FileName": "Customer_outstanding"
            , "FormatType": "pdf"
            , "params": {
                Customer: this.Customer_ID,
                // AsOnDate: From_Date,
                From_Date: this.searchobject.From_Date ? moment(this.searchobject.From_Date).format('YYYY-MM-DD') : "",
                To_Date: this.searchobject.To_Date ? moment(this.searchobject.To_Date).format('YYYY-MM-DD') : "",
                FI_ID: '',
                DTag: FIData.toString(),
                With_PDC: this.f_chkNum(this.searchobject.With_PDC),
                PostDate: From_Date
            }
        };
        // return;
        this.busy = this.commonReportService.GetJasperReport(data).subscribe(response => {
            var filename = '';
            if (response) {
                var error = '';
                error = response["error"];
                filename = response["FilePath"];
                if (filename.length > 0) {
                    window.open(filename, '_blank');
                }
            }
        });
    }

    SaveCustomerOutstandingDispute(data) {
        data.DisputedBy = this.unitInfo._id;
        const row = this.CustOutstandingRowData.find(item => item.FI_ID == data.FI_ID);
        if (!row) return;

        if (data.IsDispute == 0) {
            data.D_Tag_Remarks = '';
            row.D_Tag_Remarks = '';
            row.Is_Dispute_Outstanding = false;
        }

        if (data.IsDispute == 1 && !data.D_Tag_Remarks) {
            row.Is_Dispute = 0;
            row.Is_Dispute_Outstanding = false;
            this.toastWarningMsg('Please Enter D.Tag Remarks');
            this.gridApiCustomerOustanding.setRowData(this.CustOutstandingRowData);
            return;
        }
        this.gridApiCustomerOustanding.setRowData(this.CustOutstandingRowData);
        this.http.post('/api/customers/SaveCustomerOutstandingDispute', data)
            .subscribe((response: any) => {
            });
    }


    OnFromDateChanges(e) {
        /* if(!this.validate_from_date(e, 0)){
            return false;
        } */
    }

    OnToDateChanges(e) {
        /*  if(!this.validate_to_date(e, 0)){
             return false;
         } */
    }

    validate_from_date(f_date, IsPageLoad) {
        var status = true;
        f_date = new Date(f_date);
        var from_date = new Date(this.unitInfo.Current_Fyear_FromDate);
        var from_date_range = Date.UTC(f_date.getFullYear(), f_date.getMonth(), f_date.getDate()) - Date.UTC(from_date.getFullYear(), from_date.getMonth(), from_date.getDate());
        if (!(from_date_range >= 0)) {
            status = false;
            if (!IsPageLoad) {
                this.toastWarningMsg("From date must be between financial date");
            }
        }
        return status;
    }

    validate_to_date(t_date, IsPageLoad) {
        var status = true;
        t_date = new Date(t_date);
        var to_date = new Date(this.unitInfo.Current_Fyear_ToDate);
        var to_date_range = Date.UTC(to_date.getFullYear(), to_date.getMonth(), to_date.getDate()) - Date.UTC(t_date.getFullYear(), t_date.getMonth(), t_date.getDate());
        if (!(to_date_range >= 0)) {
            status = false;
            if (!IsPageLoad) {
                this.toastWarningMsg("To date must be between financial date");
            }
        }
        return status;
    }

    customerOustandingFilter() {
        var self = this;
        let startDate = moment(this.searchobject.From_Date).format('YYYY-MM-DD');
        let endDate = moment(this.searchobject.To_Date).format('YYYY-MM-DD'); 

        const filteredRows = this.CustOutstandingRowData_1.filter(row => {
        let postDate = moment(row.Post_Date).format('YYYY-MM-DD');
        return postDate >= startDate && postDate <= endDate; 
        });

        this.CustOutstandingRowData = filteredRows;

        var TotalRowData = { "Doc_No": "Total Count : " + this.CustOutstandingRowData.length, "OverDays": "Total :", "Total_BillAmount": 0, "ClrAmt": 0, "Outstanding": 0 };

        TotalRowData.Total_BillAmount = (this.CustOutstandingRowData.reduce(function (acc, sum) {
            return acc + (self.f_chkNum(sum.Total_BillAmount) * self.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
        TotalRowData.ClrAmt = (this.CustOutstandingRowData.reduce(function (acc, sum) {
            return acc + (self.f_chkNum(sum.ClrAmt) * self.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);
        TotalRowData.Outstanding = (this.CustOutstandingRowData.reduce(function (acc, sum) {
            return acc + (self.f_chkNum(sum.Outstanding) * self.f_chkNum(sum.DB_Cr_Ind));
        }, 0)).toFixed(2);

        setTimeout(() => {
            this.gridApiCustomerOustanding.setPinnedBottomRowData([TotalRowData]);
        }, 200);
        setTimeout(() => {
            if (this.CustOutstandingRowData.length > 0) {
                this.gridApiCustomerOustanding.getModel().getRow(0).setSelected(true);
            }
            let allColumnIds = [];
            this.gridColumnApiCustomerOustanding.getAllColumns().forEach(function (column) {
                allColumnIds.push(column.colId);
            });
            this.gridColumnApiCustomerOustanding.autoSizeColumns(allColumnIds);
            this.gridApiCustomerOustanding.sizeColumnsToFit();
        }, 100);
    }

    ClearDateRange() {
        this.searchobject.From_Date = this.Config_Leger_From_Date;
        this.searchobject.To_Date = new Date();
        this.Custfiltervalue = '';
        $('#filter-text-box1').focus();
        this.customerOustandingmain();
    }

    EnableDateRange() {
        var self = this;
        this.searchobject.Enable_DateRange = (this.searchobject.Enable_DateRange == true ? true : false);
        if (this.searchobject.Enable_DateRange == true) {
            this.searchobject.From_Date = this.Config_Leger_From_Date;
            this.searchobject.To_Date = new Date();
        }
        else {
            this.searchobject.From_Date = "";
            this.searchobject.To_Date = "";
            this.CustOutstandingRowData = this.CustOutstandingRowData_1;
            setTimeout(() => {
                var TotalRowData = { "Doc_No": "Total Count : " + this.CustOutstandingRowData.length, "OverDays": "Total :", "Total_BillAmount": 0, "ClrAmt": 0, "Outstanding": 0 };

                TotalRowData.Total_BillAmount = (this.CustOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.Total_BillAmount) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);
                TotalRowData.ClrAmt = (this.CustOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.ClrAmt) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);
                TotalRowData.Outstanding = (this.CustOutstandingRowData.reduce(function (acc, sum) {
                    return acc + (self.f_chkNum(sum.Outstanding) * self.f_chkNum(sum.DB_Cr_Ind));
                }, 0)).toFixed(2);

                setTimeout(() => {
                    this.gridApiCustomerOustanding.setPinnedBottomRowData([TotalRowData]);
                }, 200);
                setTimeout(() => {
                    if (this.CustOutstandingRowData.length > 0) {
                        this.gridApiCustomerOustanding.getModel().getRow(0).setSelected(true);
                    }
                    let allColumnIds = [];
                    this.gridColumnApiCustomerOustanding.getAllColumns().forEach(function (column) {
                        allColumnIds.push(column.colId);
                    });
                    this.gridColumnApiCustomerOustanding.autoSizeColumns(allColumnIds);
                    this.gridApiCustomerOustanding.sizeColumnsToFit();
                }, 100);


                /*  this.rowClassRules = {
                     "cheque-return": function (params) {
                         var Chq_return = params.data.Cheque_Return_Status;
                         return Chq_return == 1;
                     }
                 };
                 */
                /*
               this.rowClassRules = {
                   "cheque-return-partial": function (params) {
                       var Chq_return_partial = params.data.Cheque_Return_Status;
                       return Chq_return_partial == 2;
                   }
               }; */

                this.rowClassRules = {
                    "disputed-row-color": function (params) {
                        return params.data.Is_Dispute == 1 || params.data.Is_Dispute_Outstanding == 1;
                    },
                    "cheque-return": function (params) {
                        return params.data.Cheque_Return_Status > 0;
                    }
                };

            }, 500);

        }
    }

    Get_With_PDC() {
        this.searchobject.With_PDC = (this.searchobject.With_PDC == true ? true : false);
        this.customerOustandingmain();
    }

    Get_On_Acc() {
        this.searchobject.On_Acc = (this.searchobject.On_Acc == true ? true : false);
        this.customerOustandingmain();
    }

    D_Tag_Remarks:any;
    oncellValueChanged(event){
        // console.log(event)
        
        this.D_Tag_Remarks = event.data.D_Tag_Remarks
        if(this.D_Tag_Remarks){
            this.CustOutstandingRowData.filter(item => {
                return item == event.data;
            })[0].Is_Dispute = 1;
            event.data.Is_Dispute = 1;
            if(event.colDef.field == 'D_Tag_Remarks'){
                Swal({
                    title: 'Outstanding Confirmation',
                    text: "Consider in outstanding ?", 
                    type: 'success',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes',
                    cancelButtonText : 'No',
                    customClass: 'swal-warning-custom'
                }).then(choice => {
                    if (choice.value) {
                         this.CustOutstandingRowData.filter(item => {
                            return item == event.data;
                        })[0].Is_Dispute_Outstanding = 1;
                        event.data.Is_Dispute_Outstanding = 1;
                        this.gridApiCustomerOustanding.setRowData(this.CustOutstandingRowData);
                        let dtag_data = {IsDispute : event.data.Is_Dispute, FI_ID : event.data.FI_ID, D_Tag_Remarks : event.data.D_Tag_Remarks, Is_Dispute_Outstanding: 1};
                        this.SaveCustomerOutstandingDispute(dtag_data);
                    }else{
                         this.CustOutstandingRowData.filter(item => {
                            return item == event.data;
                        })[0].Is_Dispute_Outstanding = 0;
                        event.data.Is_Dispute_Outstanding = 0;
                        this.gridApiCustomerOustanding.setRowData(this.CustOutstandingRowData);
                    }
                });
            }
            this.gridApiCustomerOustanding.setRowData(this.CustOutstandingRowData);
           
            if(event.colDef.field == 'D_Tag_Remarks' || event.colDef.field == 'Is_Dispute'){ 
                let dtag_data = {IsDispute : event.data.Is_Dispute, FI_ID : event.data.FI_ID, D_Tag_Remarks : event.data.D_Tag_Remarks, Is_Dispute_Outstanding: event.data.Is_Dispute_Outstanding ? 1 : 0};
                this.SaveCustomerOutstandingDispute(dtag_data);
            }
            
        }else{
            this.CustOutstandingRowData.filter(item => {
                return item == event.data;
            })[0].Is_Dispute = 0;
            event.data.Is_Dispute = 0;
            this.gridApiCustomerOustanding.setRowData(this.CustOutstandingRowData);
        }
    }
}

